import styled from 'styled-components'
import { Link } from 'gatsby'

export const Wrapper = styled.div`
  height: 100%;
  position: relative;
`

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: ${props => (props.large ? '10px 0' : '1px 0')};
  width: 100%;
`

export const StyledLink = styled(Link)`
  &&& {
    color: ${({ theme }) => theme.colors.white};
    :active {
      color: ${({ theme }) => theme.colors.white};
    }

    ::before {
      display: none;
    }
  }
`

export const Title = styled.span`
  font-size: 1.3rem;
  font-weight: bold;
  align-self: center;
  margin: 5px;
  color: ${({ theme }) => theme.colors.white};
`

export const Span = styled.span`
  font-size: 1rem;
  padding-left: 5px;
`

export const FilterWrapper = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding: 10px;
  width: 100%;
`

export const ResetButton = styled.button`
  display: flex;
  background-color: ${({ theme }) => theme.colors.white};
  border: none;
  border-right: 1px solid black;
  margin-right: 5px;
  padding: 0 5px;
  :hover {
    cursor: pointer;
  }
`